import { clsx } from 'clsx'

import { getScoreStatus } from '../helpers/getScoreStatus'
import styles from './Score.module.scss'

type Size = 'compact' | 'default'

interface Props {
    size?: Size
    value: number
    ewt?: number
    mps?: number
    isInaccurate?: boolean
    isLowFrequency?: boolean
    variance?: number
    className?: string
    expected?: number
    actual?: number
}

export const Score = ({
    value,
    size,
    mps,
    ewt,
    isInaccurate,
    variance,
    className,
    isLowFrequency,
    expected,
    actual,
}: Props) => {
    const variant = getScoreStatus({ mps, value, ewt, variance, isInaccurate, isLowFrequency, actual, expected })

    const rounded = value.toFixed(isLowFrequency ? 1 : 2)

    return (
        <span className={clsx(className, styles.chip, styles[variant], size ? styles[size] : styles.default)}>
            {value ? (isLowFrequency ? `${rounded}%` : rounded) : '-'}
        </span>
    )
}
